














import {Vue, Component, Prop} from 'vue-property-decorator';
@Component
export default class InPlaceMessageBox extends Vue{
    @Prop() message?: string;
    @Prop() messageType?: string;
    @Prop() buttons?: string;
    
    ok(){
        this.$emit("button-clicked",'ok');
    }
    cancel(){
        this.$emit("button-clicked",'cancel');
    }
    yes(){
        this.$emit("button-clicked",'yes');
    }
    no(){
        this.$emit("button-clicked",'no');
    }

}
